<div class="progress-bar-wrapper">
  <div [ngClass]="getProjectBarContainerColor()" class="progress-bar-container">
    <div
      class="progress-bar"
      [ngClass]="getProjectBarColor()"
      [ngStyle]="{ width: progress + '%' }"
    ></div>
  </div>
  <div class="progress-bar-percentage">
    <span>{{ percentage }}%</span>
  </div>
</div>
